<ng-container [formGroup]="form" *ngIf="form">
  <nf-form-control *ngIf="actionCodes.length > 0" label="Action" compact>
    <ng-select
      id="action"
      name="action"
      [items]="actionCodes"
      placeholder="Select Action"
      formControlName="action"
      [closeOnSelect]="true"
    >
      <ng-template ng-option-tmp let-item="item">
        <div [ngbTooltip]="item" container="body" class="ellipsis">
          {{ item }}
        </div>
      </ng-template>
    </ng-select>
  </nf-form-control>

  <nf-form-control
    *ngIf="descriptionCodes.length > 0"
    label="Description"
    compact
  >
    <ng-select
      id="description"
      name="description"
      placeholder="Select Description"
      [items]="descriptionCodes"
      formControlName="description"
      [closeOnSelect]="true"
    >
      <ng-template ng-option-tmp let-item="item">
        <div [ngbTooltip]="item" container="body" class="ellipsis">
          {{ item }}
        </div>
      </ng-template>
    </ng-select>
  </nf-form-control>
  <!-- Single note field. Optional + collapsible (single hold/accept) shows a
       toggle to expand it; required or other consumers show it inline. -->
  <button
    *ngIf="collapsibleOptionalNote && !isNoteRequired"
    type="button"
    class="note-opt-btn"
    data-cy="toggle-optional-note"
    (click)="toggleNote()"
  >
    <span class="note-opt-arrow" [class.open]="noteExpanded">▶</span>
    {{ noteExpanded ? 'Note (optional)' : 'Add optional note' }}
  </button>
  <nf-form-control
    *ngIf="noteVisible"
    [label]="collapsibleOptionalNote && !isNoteRequired ? '' : 'Note'"
    for="noteFormControl"
    [customErrorMessages]="validationMessages.notesValidationMessages"
  >
    <div
      *ngIf="isNoteRequired"
      class="note-required-reason"
      data-cy="note-required-reason"
    >
      A note of at least 3 words is required.
    </div>
    <textarea
      class="form-control"
      id="noteFormControl"
      formControlName="note"
      data-cy="note"
      rows="5"
      [hsAutofocus]="form.invalid"
    ></textarea>
  </nf-form-control>
  <nf-form-control *ngIf="showNoteHandlingToggle">
    <nf-toggle
      data-cy="toggle"
      [states]="noteHandlingToggleStates"
      formControlName="noteHandlingToggle"
    ></nf-toggle>
  </nf-form-control>
</ng-container>
